import {Component, OnInit} from '@angular/core';
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {AsReportedInsiderNullEntry} from "../../../../../api/models/as-reported-insider-null-entry";
import {QualityGateService} from "../../../../../api/services/quality-gate.service";
import {MessageService} from "primeng/api";
import {QualityGateSubmission} from "../../../../../api/models/quality-gate-submission";
import {QualityGateFilter} from "../../../../../api/models/quality-gate-filter";
import {QualityGateMultiSubmission} from "../../../../../api/models/quality-gate-multi-submission";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
@Component({
  selector: 'app-insider-null-processed',
  // imports: [],
  templateUrl: './processed.component.html',
  styleUrl: './processed.component.css',
  standalone: false,
})
export class InsiderNullProcessedComponent implements OnInit {
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  processedInsiderNullEntries: AsReportedInsiderNullEntry[] = [];
  tooltipForGroupExclude = "Select at least two rows and ensure every selected row has a relationship value";
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedInsiderNullEntries();
  }

  onExcludeClick(share: AsReportedInsiderNullEntry) {
    const submission: QualityGateSubmission = {
      qualityGateType: "As_Reported_Insider_Null",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      transactionTypeNullSubmission: {
        entryId: 0,
      },
      securityTypeNullSubmission: {
        entryId: 0,
      },
      nonIndividualRelationshipSubmission: {
        entryId: 0,
        relationShip: "",
      },
      expirationAndDurationAreNullSubmission: {
        entryId: 0
      },
      asReportedInsiderNullSubmission: {
        entryId: share.entryId ?? 0
      }
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getProcessedInsiderNullEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }


  onSearch() {
       const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedInsiderNullEntries();
  }
   preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  getProcessedInsiderNullEntries() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "As_Reported_Insider_Null",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedInsiderNullEntries =
          value.asReportedInsiderNullEntries ?? [];
        // console.log('test1', this.unprocessedNonIndividualRelationshipEntries);
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedInsiderNullEntries?.[0]?.totalCount ??
          0;
        this.isLoading = false;
      },
    });
  }

  get canGroupExclude(): boolean {
    if (!this.selectedTag || this.selectedTag.length < 2) {
      return false;
    }

    const allHaveCurrent = this.selectedTag.every(
      (share) => !!share.issuerRelationship
    );
    if (!allHaveCurrent) {
      return false;
    }
    return true;
  }

  onGroupExclusionClick() {
    const submissions = this.selectedTag
      .filter(
        (share) => share.entryId !== undefined && share.issuerRelationship
      )
      .map((share) => ({
        entryId: share.entryId as number,
        relationShip: share.issuerRelationship as string,
      }));
    const submission: QualityGateMultiSubmission = {
      nonIndividualRelationshipSubmissions: submissions,
      indeterminable: true,
      qualityGateType: "Non_Individual_relationship",
    };

    this._qualityGateService.multiSubmission(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.selectedTag = [];
        this.getProcessedInsiderNullEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }


}
